<!-- Sidebar main menu -->
<app-sidebar class="sidebar-wrap sidebar-overlay shadow-sm"></app-sidebar>
<!-- Add pushcontent or fullmenu instead overlay , keep 'sidebar-[choice here]' -->
<!-- Sidebar main menu ends-->
<!-- <p-toast key="main"></p-toast> -->
<!-- Begin page -->
<main class="has-header home-layout bg-dark">
  <!-- Header -->
  <app-headermenu class="container-fluid header"></app-headermenu>
  <!-- Header ends -->
  <!-- main page content -->
  <div
    [ngStyle]="
      isAiSellingPage
        ? { background: 'rgb(245,245,245)', overflow: 'hidden' }
        : {}
    "
    class="main-container container-fluid has-border-radius"
  >
    <app-global-spinner></app-global-spinner>
    <router-outlet></router-outlet>
  </div>

  <!-- main page content ends -->
  <!-- fluid footer at bottom of page -->
  <!--<app-footerinfo class="container-fluid d-block"></app-footerinfo>-->
  <!-- fluid footer at bottom of page ends -->
  <app-navbar class="bottom-nav d-md-none"></app-navbar>
</main>
<!-- Page ends-->
